class SegmentDelegate {
    setChannel(channel) {
        this.setState((prevState) => {
            return { channel };
        });
    }

    setProducts(products) {
        this.setState((prevState) => {
            return { products };
        });
    }

    setSegment(segment) {
        this.setState((prevState) => {
            return { segment };
        });
    }

    setViewMode(viewMode) {
        this.setState({ viewMode, selectedStoreIds: [], hasOverride: false });
    }
}

export default SegmentDelegate;
